import { DASHBOARD_PDF_DOWNLOAD } from './../../shared/constants/urlEndPoints';
import { setIsDownloadMetricsBoardPDF } from './../actions/dashboardAction';
import { put, takeLatest } from 'redux-saga/effects';
import actionTypes from '../types/dashboardTypes';
import { centeredNotification } from '../../utils/utility';
import SendRequest from '../../shared/services/sendRequest.service';
import { DASHBOARD_POWER_BI } from '../../shared/constants/urlEndPoints';
import { APPLICATION_ID } from '../../shared/constants/commonConstants';
import { submitDashboardFilterSuccess } from '../actions/dashboardAction';
import ApplicationDetail from '../../shared/services/applicationDetail.service';

function* fetchDashboardSaga({ payload: { dashboardType, onCallback } }: any): Generator {
  const url = `${process.env.REACT_APP_BASE_URL}${DASHBOARD_POWER_BI}`;
  try {
    const payloadData = {
      applicationId: APPLICATION_ID,
      dashboardType,
      profileId: ApplicationDetail.instance.getProfileId(),
    };
    const response: any = yield SendRequest.instance.post(url, payloadData);

    if (response && response.isSuccess) {
      yield put(submitDashboardFilterSuccess(response));
    }
  } catch (e) {
    centeredNotification('Error occured while fetching dashboard data, please try again.');
  } finally {
    onCallback();
  }
}

function* downloadMetricsBoardPDFSaga({ payload: { dashboardType, filters } }: any): Generator {
  const url = `${process.env.REACT_APP_BASE_URL}${DASHBOARD_PDF_DOWNLOAD}`;
  try {
    const payloadData = {
      applicationId: APPLICATION_ID,
      dashboardType,
      profileId: ApplicationDetail.instance.getProfileId(),
      filters,
    };

    const {
      isSuccess = false,
      file,
      errorMessage = false,
    }: any = yield SendRequest.instance.post(url, payloadData);

    yield put(setIsDownloadMetricsBoardPDF(false));
    if (isSuccess) {
      const linkSource = 'data:' + 'application/pdf' + ';base64,' + file;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;
      downloadLink.download = `metrics-dashboard.pdf`;
      document.body.appendChild(downloadLink);
      downloadLink.click();

      centeredNotification('File downloaded successfully.', 'success');
    } else {
      centeredNotification(errorMessage, 'error');
    }

  } catch (e) {
    yield put(setIsDownloadMetricsBoardPDF(false));
    centeredNotification('Error occured while downloading PDF, please try again.');
  }
}

export function* watchDashboardAction(): any {
  yield takeLatest(actionTypes.DASHBOARD_FILTER_REQUESTED, fetchDashboardSaga);
  yield takeLatest(actionTypes.DOWNLOAD_METRICS_BOARD_PDF_REQUESTED, downloadMetricsBoardPDFSaga);
}

export default watchDashboardAction;
